<template>
  <section class="bg-white pb-24 pt-4">
    <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
      <div class="relative overflow-hidden rounded-[2rem] bg-background-dark px-8 py-16 text-white lg:px-16 lg:py-20">
        <div class="pointer-events-none absolute inset-0" aria-hidden="true">
          <!-- radial-gradient glows, not filter:blur() — large blur overflows the iOS WebKit texture limit and paints white blocks -->
          <div class="absolute -left-10 top-0 h-80 w-80" style="background: radial-gradient(closest-side, rgba(255, 174, 0, 0.25), transparent 70%)"></div>
          <div class="absolute -bottom-16 right-0 h-72 w-72" style="background: radial-gradient(closest-side, rgba(255, 174, 0, 0.15), transparent 70%)"></div>
        </div>

        <div class="relative flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
          <div class="max-w-[640px]">
            <h2 class="text-4xl font-black leading-[1.05] tracking-[-0.02em] sm:text-5xl">
              {{ t('cta.title') }}
            </h2>
            <p class="mt-4 text-lg text-white/70">{{ t('cta.subtitle') }}</p>
          </div>

          <div class="flex w-full flex-col gap-3 sm:flex-row lg:w-auto">
            <RouterLink
              :to="getRoute('/contact')"
              class="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-7 py-4 text-base font-bold text-text-main shadow-[0_8px_30px_-8px_rgba(255,174,0,0.7)] transition-transform hover:-translate-y-0.5"
            >
              {{ t('cta.start_project') }}
              <span class="material-symbols-outlined text-[20px]">arrow_forward</span>
            </RouterLink>
            <RouterLink
              :to="getRoute('/contact')"
              class="inline-flex items-center justify-center rounded-xl border border-white/20 px-7 py-4 text-base font-bold text-white transition-colors hover:bg-white/10"
            >
              {{ t('cta.book_call') }}
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { useI18n } from 'vue-i18n';
const { t, locale } = useI18n();

const getRoute = (path: string) => {
  const currentLocale = locale.value;
  if (path.startsWith('/')) return `/${currentLocale}${path}`.replace('//', '/');
  return path;
};
</script>
